import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { CopyrightOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import React, { Fragment } from 'react';
import { GlobalFooter } from "./GlobalFooter";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Footer = Layout.Footer;
var DefaultFooter = function DefaultFooter(_ref) {
  var links = _ref.links,
    copyright = _ref.copyright,
    style = _ref.style,
    className = _ref.className,
    prefixCls = _ref.prefixCls;
  return /*#__PURE__*/_jsx(Footer, {
    className: className,
    style: _objectSpread({
      padding: 0
    }, style),
    children: /*#__PURE__*/_jsx(GlobalFooter, {
      links: links,
      prefixCls: prefixCls,
      copyright: copyright === false ? null : /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(CopyrightOutlined, {}), " ", copyright]
      })
    })
  });
};
export { DefaultFooter };